<template>
<!-- 活动说明 -->
<section style="margin-top:30px">
  <div style="width: 96%;margin: auto;"
  v-if="addShopType == 1 || addShopType == 2 || addShopType == 3 || addShopType == 5 || addShopType == 6 || addShopType == 7">
    <el-form :model="addGoodsForm" label-width="120px">

      <el-row v-show="addShopType == 1 || addShopType == 2 || addShopType == 3">
        <el-col :span="8">
        <el-form-item label="店铺:" prop="goodBrand" v-show="newType == 1 || newType == 4">
          <el-select v-model="couponForm.bbId" filterable placeholder="请选择店铺" @change="handleDp" :disabled="disabledFour" style="width: 280px">
            <el-option v-for="(item, index) in exhibitingBrands" :key="index" :value="item.id" :label="item.name"/>
          </el-select>
        </el-form-item>
        </el-col>
        <el-col :span="8" v-show="addShopType == 2 || addShopType == 3">
        <el-form-item label="商品品牌">
          <el-cascader placeholder="请选择" v-model="addGoodsForm.goodBrand" :options="optionExhibitions"
          filterable clearable @change="handleSppp" :disabled="disabledFour" style="width: 80%"/>
        </el-form-item>
        </el-col>
        <el-col :span="8">
        <el-form-item label="商品编码:" prop="goodModelCode">
          <el-autocomplete v-model="addGoodsForm.goodModelCode" :fetch-suggestions="querySearchAsync"
          placeholder="请输入商品编码（10字以内）" @select="handleSelect" style="width: 80%"
          :maxlength="10" :debounce="0" :trigger-on-focus="false" :disabled="disabledFour"/>
        </el-form-item>
        </el-col>
      </el-row>

      <el-row v-show="addShopType == 1 || addShopType == 2 || addShopType == 3">
        <el-col :span="8">
        <el-form-item label="商品名称" prop="title">
          <el-input v-model="addGoodsForm.title" placeholder="请输入商品名称（20字以内）"
          maxlength="20" :disabled="disabledFour" style="width: 80%"/>
        </el-form-item>
        </el-col>
        <el-col :span="8">
        <el-form-item label="市场价:" prop="marketPrice">
          <el-input v-model="addGoodsForm.marketPrice" @blur="changeblur()" style="width: 80%"
          placeholder="请输入市场价" maxlength="10" :disabled="disabledFour"
          onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
        </el-form-item>
        </el-col>
        <el-col :span="8" v-show="addShopType == 2 || addShopType == 3">
        <el-form-item label="单　　位:" prop="promotionPrice">
          <el-select filterable v-model="addGoodsForm.unit" placeholder="请选择" :disabled="seeDisabled" style="width: 80%">
            <el-option v-for="item in danwei" :key="item.id" :value="item.Id" :label="item.Name"/>
          </el-select>
        </el-form-item>
        </el-col>
      </el-row>
      
      <el-row v-show="addShopType == 2">
        <el-col :span="8">
        <el-form-item label="秒杀方式:" prop="seckillModeId">
          <el-select filterable v-model="addGoodsForm.seckillModeId" placeholder="请选择秒杀方式" :disabled="seeDisabled" style="width: 80%">
            <el-option v-for="(item, index) in secondKillModeList" :key="index" :value="item.Id" :label="item.Name"/>
          </el-select>
        </el-form-item>
        </el-col>
        <el-col :span="8">
        <el-form-item label="秒杀价:" prop="seckillPrice">
          <el-input v-model="addGoodsForm.seckillPrice" @blur="changeblur()"
          placeholder="请输入秒杀价" maxlength="10" :disabled="seeDisabled" style="width: 80%"
          onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
        </el-form-item>
        </el-col>
        <el-col :span="8">
        <el-form-item label="秒杀定金:" prop="seckillDeposit" v-if="addGoodsForm.seckillModeId == 2">
          <el-input v-model="addGoodsForm.seckillDeposit" @blur="changeblur()" style="width: 80%"
          placeholder="请输入秒杀定金" maxlength="10" :disabled="seeDisabled"
          onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
        </el-form-item>
        </el-col>
      </el-row>

      <el-row v-show="addShopType == 3">
        <el-col :span="8">
        <el-form-item label="拼团方式:" prop="groupModeId">
          <el-select v-model="addGoodsForm.groupModeId" placeholder="请选择拼团方式" filterable :disabled="seeDisabled" style="width: 80%">
            <el-option v-for="(item, index) in groupTypeList" :key="index" :value="item.Id" :label="item.Name"/>
          </el-select>
        </el-form-item>
        </el-col>
        <el-col :span="8">
        <el-form-item label="团购价:" prop="groupPrice">
          <el-input v-model="addGoodsForm.groupPrice" @blur="changeblur()" style="width: 80%"
          placeholder="请输入团购价" maxlength="10" :disabled="seeDisabled"
          onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
        </el-form-item>
        </el-col>
        <el-col :span="8">
        <el-form-item label="团购定金:" prop="groupDeposit" v-if="addGoodsForm.groupModeId == 2">
          <el-input v-model="addGoodsForm.groupDeposit" @blur="changeblur()" style="width: 80%"
          placeholder="请输入团购定金" maxlength="10" :disabled="seeDisabled"
          onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
        </el-form-item>
        </el-col>
      </el-row>

      <el-row v-show="addShopType == 2 || addShopType == 3">
        <el-col :span="8" v-show="addShopType == 2">
        <el-form-item label="秒杀数量:" prop="seckillStock">
          <el-input v-model="addGoodsForm.seckillStock" placeholder="请选择秒杀数量" maxlength="7"
          oninput="value=value.replace(/[^\d]/g,'')" :disabled="seeDisabled" style="width: 80%"
          onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
        </el-form-item>
        </el-col>
        <el-col :span="8" v-show="addShopType == 3">
        <el-form-item label="成团人数:" prop="groupNumber">
          <el-input v-model="addGoodsForm.groupNumber" placeholder="请选择成团人数" maxlength="7" :disabled="seeDisabled"
          oninput="value=value.replace(/[^\d]/g,'')" style="width: 80%"
          onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
        </el-form-item>
        </el-col>
        <el-col :span="8">
        <el-form-item label="佣金比例:" prop="commissionRate">
          <el-input v-model="addGoodsForm.commissionRate" placeholder="请输入佣金比例"
          maxlength="6" :disabled="seeDisabled" style="width: 80%"
          onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
        </el-form-item>
        </el-col>
      </el-row>
      
      <el-row v-show="addShopType == 1 || addShopType == 2 || addShopType == 3">
        <el-col :span="8" v-show="addShopType == 1">
        <el-form-item label="促销价:" prop="promotionPrice">
          <el-input v-model="addGoodsForm.promotionPrice" @blur="changeblur()"
          placeholder="请输入促销价" maxlength="10" :disabled="seeDisabled" style="width: 80%"
          onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
        </el-form-item>
        </el-col>
        <el-col :span="8" v-show="addShopType == 2">
        <el-form-item label="秒杀时间:" prop="spikeTime">
          <div style="display:flex;">
          <el-select filterable v-model="addGoodsForm.spikeDate" placeholder="请选择日期" style="width: 50%;margin-right:10px;" :disabled="seeDisabled">
            <el-option v-for="(item, index) in msriqiArr" :key="index" :value="item.Id" :label="item.Name"/>
          </el-select>
          <el-time-select v-model="addGoodsForm.spikeTime" placeholder="选择时间" style="width: 26%"
          :picker-options="{ start: '00:00', step: '01:00', end: '23:00' }" :disabled="seeDisabled"/>
          </div>
        </el-form-item>
        </el-col>
        <el-col :span="8">
        <el-form-item label="商品优势:" prop="advantageOne">
          <el-input type="text" v-model="addGoodsForm.advantageOne" :disabled="seeDisabled"
          placeholder="请输入商品优势（20字以内）" maxlength="20" style="width: 80%"/>
        </el-form-item>
        </el-col>
      </el-row>
      
      <!-- 商品视频 -->
      <el-form-item label="商品视频:" v-if="addShopType == 2 || addShopType == 3">
        <div v-if="videoSrc" class="videoClass">
          <span @click="newSeevideo(videoSrc)" class="previewingVideo">
            <img :src="videoImg" v-if="videoImg">
            <img src="../../assets/img/spfm.png" v-else>
            <div class="iconcontainer"><img src="../../assets/img/play.png" class="playIcon"/></div>
          </span>
          <img src="../../assets/img/aicon36.png" @click="delvideo()" v-if="videoSrc" class="chahao"/>
        </div>
        <el-upload v-else class="avatar-uploader proportionImg" action="" accept="video/*" :before-upload="handleFile">
          <el-progress type="circle" v-if="videoFlag" :percentage="videoUploadPercent" :width="80" :height="80"/>
          <i v-else class="el-icon-plus avatar-uploader-icon"/>
        </el-upload>
        <div style="color:#888;">视频格式仅支持: mp4. 视频大小不能超过 50MB !</div>
      </el-form-item>

      <!-- 商品图片 -->
      <el-form-item label="商品图片:" prop="goodsImgUrl" class="uploadActiveForm"
      v-show="addShopType == 1 || addShopType == 2 || addShopType == 3">
        <div class="uploadActive">
          <el-upload v-show="isdisabled" class="avatar-uploader proportionImg" :disabled="seeDisabled"
            style action :show-file-list="false" :before-upload="beforeAvatarUpload">
            <div v-if="goodsImgUrl"> <img :src="goodsImgUrl" style="width: 80px; height: 80px"/> </div>
            <div v-if="!goodsImgUrl">  <i class="el-icon-plus avatar-uploader-icon"></i> </div>
          </el-upload>
        </div>
        <div style="color: #888;"> 建议尺寸：比例为1：1　支持的图片格式：jpg、png </div>
      </el-form-item>
      
      <el-row v-show="addShopType == 5 || addShopType == 6 || addShopType == 7">
        <el-col :span="8">
        <el-form-item label="礼品数量:" prop="stock">
          <el-input v-model="addGoodsForm.stock" placeholder="请选择礼品数量" maxlength="7"
          oninput="value=value.replace(/[^\d]/g,'')" :disabled="seeDisabled" style="width: 66%"
          onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" @blur="addGoodsForm.stock = $event.target.value"/>
        </el-form-item>
        </el-col>
        <el-col :span="8" v-show="addShopType == 5">
        <el-form-item label="领取说明(选填)：" label-width="150px">
          <el-input v-model="addGoodsForm.receiveDesc" placeholder="最多输入20个汉字"
          maxlength="20" :disabled="seeDisabled" style="width: 66%"/>
        </el-form-item>
        </el-col>
        <el-col :span="8" v-show="addShopType == 5">
        <el-form-item label="核销时间：">
          <div style="display: flex;">
          <el-select filterable v-model="addGoodsForm.writeOffDate" placeholder="请选择日期" style="width: 30%;" :disabled="seeDisabled">
            <el-option v-for="(item, index) in hxriqiArr" :key="index" :value="item.Id" :label="item.Name"/>
          </el-select>
          <label style="margin: 0 10px;">至</label>
          <el-select filterable v-model="addGoodsForm.writeOffEndDate" placeholder="请选择日期" style="width: 30%;" :disabled="seeDisabled">
            <el-option v-for="(item, index) in hxriqiArr" :key="index" :value="item.Id" :label="item.Name"/>
          </el-select>
          <!-- <el-time-select v-model="addGoodsForm.writeOffBeginTime" placeholder="起始时间"
          :picker-options="{ start: '08:30', step: '00:15', end: '18:30'}" style="margin-right:10px;"/>
          <el-time-select v-model="addGoodsForm.writeOffEndTime" placeholder="结束时间"
          :picker-options="{ start: '08:30', step: '00:15', end: '18:30', minTime: addGoodsForm.writeOffBeginTime}"/> -->
          </div>
        </el-form-item>
        </el-col>
      </el-row>
      
      <div v-show="addShopType == 5 || addShopType == 6 || addShopType == 7">
        <!-- 已添加 礼品列表 -->
        <div v-for="(item,index) in journalArr" :key="index">
          <el-row :gutter="20" v-if="journalArr.length >= 1">
            <div class="primarybtn" v-show="!seeDisabled"><el-button type="warning" size="small" @click="shanchu(index)">　刪除　</el-button></div>
            <el-col :span="8">
            <el-form-item label="礼品名称:">
              <el-input v-model="item.name" disabled style="width: 68%;"/>
            </el-form-item>
            </el-col>
            <el-col :span="10">
            <el-form-item label="礼品图片:">
              <div class="upPictures">
                <div class="multigraph">
                  <el-image :src="item.imgUrl" style="width: 80px; height:80px;"/>
                </div>
              </div>
            </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row :gutter="20" v-show="!seeDisabled">
          <div class="primarybtn" v-show="journalArr.length <= 10">
            <el-button type="primary" size="small" @click="addJournal()">添加礼品</el-button>
          </div>
          <el-col :span="8">
          <el-form-item label="礼品名称:">
            <el-input v-model="anwser" placeholder="请输入礼品名称(20字以内)" maxlength="20" style="width: 68%;"/>
          </el-form-item>
          </el-col>
          <el-col :span="10">
          <el-form-item label="礼品图片:">
            <div class="upPictures">
              <div class="multigraph" v-show="detailImgUrlarr">
                <el-image :src="detailImgUrlarr" style="width: 80px;height:80px;"/>
              </div>
              <!-- 上传图片 -->
              <el-upload action multiple v-show="!detailImgUrlarr" :before-upload="lpPucUpload"
              accept=".png, .jpg,.jpeg" style="float: left;margin-right: 10px">
                <i class="el-icon-plus upBtn"/>
              </el-upload>
            </div>
            <span class="spPicWenan">
              <p>1.支持JPG,PNG格式图片，单张最大支持5MB；</p>
              <p>2.礼品是否添加成功，以礼品列表内容为准。</p>
            </span>
          </el-form-item>
          </el-col>
        </el-row>
      </div>

      <el-row>
        <el-col :span="8">
        
        </el-col>
        <el-col :span="8">
        
        </el-col>
        <el-col :span="8">
        
        </el-col>
      </el-row>
      
      <!-- <el-col :span="8" v-show="addShopType == 1 || addShopType == 2 || addShopType == 3">
        <el-form-item label="甄惠装价:" prop="tzrPrice">
          <el-input @blur="changeblur()" v-model="addGoodsForm.tzrPrice"
            width="100%" placeholder="请输入甄惠装价" maxlength="10" :disabled="disabledFour"
            onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
        </el-form-item>
      </el-col> -->
      
      <el-form-item label="打卡店铺:" v-show="addShopType == 6">
        <el-button type="danger" size="mini" @click="handleXzdp()">选择店铺</el-button> <br>
        <span>已选择 {{alreadyChoose.length}} 个店铺：</span>
        <div class="dakadianpu" v-show="alreadyChoose.length>0">
          <p v-for="id in alreadyChoose" :key="id">{{getdianpuname(id)}}</p>
        </div>
      </el-form-item>
      <el-form-item label="连单数量:" v-show="addShopType == 7">
        <el-input v-model="liandanshul" placeholder="请输入需连单数"
         style="width:260px" maxlength="10" onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"/> 单
      </el-form-item>
      <el-form-item label="每单金额:" v-show="addShopType == 7">
        <el-input v-model="meidanjine" placeholder="请输入每单最低消费金额"
         style="width:260px" maxlength="10" onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"/> 元
      </el-form-item>
      <el-form-item v-show="addShopType == 7">
        <p style="width: 78%;height: 20px;line-height: 20px;">
          温馨提示：联单规则是指用户在整个活动有效期限内，在多个活动商家店铺进行连续消费，且消费金额及订单数达到规定门槛，即可兑换相应礼品。
        </p>
      </el-form-item>
      <el-form-item label="规则说明:" style="width: 80%" v-if="addShopType == 6 || addShopType == 7">
        <el-input type="textarea" v-model="dddklGzsm" :rows="8" maxlength="1000" v-show="addShopType == 6"/>
        <el-input type="textarea" v-model="ldlGzsm" :rows="8" maxlength="1000" v-show="addShopType == 7"/>
      </el-form-item>
      <!-- <el-form-item label="" prop="advantageTwo" style="width: 45%" v-show="addShopType == 1 || addShopType == 2 || addShopType == 3">
        <el-input type="text" v-model="addGoodsForm.advantageTwo" :disabled="seeDisabled"
          placeholder="请输入商品优势（10字以内）" maxlength="10"/>
      </el-form-item>
      <el-form-item label="" prop="advantageThree" style="width: 45%" v-show="addShopType == 1 || addShopType == 2 || addShopType == 3">
        <el-input type="text" v-model="addGoodsForm.advantageThree" :disabled="seeDisabled"
          placeholder="请输入商品优势（10字以内）" maxlength="10"/>
      </el-form-item> -->
      <!-- 富文本 -->
      <div v-if="addShopType !== 4">
        <el-form-item label="商品简介:" style="width: 80%" v-show="addShopType == 1 || addShopType == 2 || addShopType == 3">
          <wjEditor :desc="addGoodsForm.productProfile" @change="contentChangeOne"/>
        </el-form-item>
        <el-form-item label="活动说明:" style="width: 80%" v-if="addShopType == 2 || addShopType == 3">
          <wjEditor :desc="addGoodsForm.activityDesc" @change="contentChangetWO"/>
        </el-form-item>
      </div>
    </el-form>
    <!-- :::::::::: 活动形式详情页 - 操作按钮 :::::::::: -->
    <div style="text-align: center;margin: 10px 0;">
      <el-button @click="cancelActiveForm('addGoodsForm')">{{ seeDisabled?'返回':'取消' }}</el-button>
      <el-button type="danger" @click="saveAddGoods_late('addGoodsForm')"
        v-if="seeSaveBtn == false" :loading="loadingBut">{{loadingButText}}</el-button>
      <el-button @click="resetOne('addGoodsForm')" style="display: none">重置</el-button>
    </div>
  </div>
  <!-- 优惠券详情 -->
  <div style="width: 96%;margin: auto;" v-if="addShopType == 4">
    <h3>优惠券信息</h3>
    <el-form :model="couponForm" ref="couponForm" label-width="120px">
      <el-form-item label="适用店铺:" prop="brandName" v-show="newType == 1 || newType == 4">
        <!-- <el-cascader v-if="!seeFormType" placeholder="请选择所属品牌" v-model="couponForm.brandName" :options="optionExhibitions"
          style="width: 280px" filterable clearable @change="handleChangeYhq" :disabled="seeDisabled"/>
        <el-input v-if="seeFormType" v-model="seebrandName" :disabled="seeDisabled" style="width: 280px"/> -->
        <el-select v-model="couponForm.bbId" filterable placeholder="请选择店铺" style="width: 280px">
          <el-option v-for="(item, index) in exhibitingBrands" :key="index" :value="item.id" :label="item.name"/>
        </el-select>
      </el-form-item>
      
      <el-row>
        <el-col :span="12">
        <el-form-item label="优惠券名称:" prop="name">
          <el-input v-model="couponForm.name" :disabled="seeDisabled"
          placeholder="请输入优惠券名称（10字以内）" maxlength="10" style="width: 60%"/>
        </el-form-item>
        </el-col>
        <el-col :span="12">
        <el-form-item label="售价:" prop="price">
          <el-input v-model="couponForm.price" placeholder="请输入优惠券的售价" maxlength="10" :disabled="seeDis || IsInterview == true"
          onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" style="width: 50%"/>&nbsp;&nbsp;元
          <el-checkbox @change="mianfei()" v-model="IsInterview" style="margin-left: 20px;" :disabled="seeDisabled">免费</el-checkbox>
        </el-form-item>
        </el-col>
      </el-row>
      
      <el-row>
        <el-col :span="12">
        <el-form-item label="优惠券面值:" prop="faceValue" style="position:relative">
          <el-input v-model="couponForm.faceValue" placeholder="请输入优惠券面值" style="width: 60%"
          maxlength="7" :disabled="seeDisabled" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
          <span style="margin-left: 10px;">元</span>
        </el-form-item>
        </el-col>
        <el-col :span="12">
        <el-form-item label="发放数量:" prop="number">
          <el-input v-model="couponForm.number" placeholder="请输入优惠券的数量" maxlength="7" :disabled="seeDisabled"
          onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" style="width: 50%"/>
        </el-form-item>
        </el-col>
      </el-row>
      
      <el-row>
        <el-col :span="12">
        <el-form-item label="使用门槛:" prop="hasThreshold">
          <el-radio v-model="hasThreshold" label="0" :disabled="seeDisabled"> 无门槛 </el-radio>
          <el-radio v-model="hasThreshold" label="1" :disabled="seeDisabled">
            满&nbsp;&nbsp;
            <el-input v-model="couponForm.useThreshold" placeholder="请输入金额" :disabled="couponForm.disableThreshold"
            maxlength="7" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" style="width: 50%"/>
            &nbsp;&nbsp;元&nbsp;&nbsp;可使用
            </el-radio>
        </el-form-item>
        </el-col>
        <el-col :span="12">
        <el-form-item label="每人可领取:" prop="receiveNumber">
          <el-input v-model="couponForm.receiveNumber" :disabled="seeDisabled"
          maxlength="7" placeholder="请输入" onkeyup="value=value.replace(/[^\d]/g,'');" style="width: 50%"/>
          &nbsp;&nbsp;张&nbsp;&nbsp;
          <!-- <el-checkbox @change="unlimited()" v-model="noLimit" :disabled="seeDisabled">无限制</el-checkbox> -->
        </el-form-item>
        </el-col>
      </el-row>
      
      <!-- 富文本 -->
      <el-form-item label="特殊说明：" style="width: 100%">
        <wjEditor :desc="couponForm.specialInstructions" @change="contentChangeThree" style="width:80%;"/>
      </el-form-item>
      
      <!-- <el-form-item label="共创推广佣金:" prop="commissionMode">
        <el-radio-group v-model="commissionMode">
          <el-col :span="12">
            <el-radio label="1" :disabled="seeDisabled">
              固定佣金 &nbsp;
              <el-input v-model="couponForm.commission" placeholder="请输入金额" :disabled="couponForm.fixedCommission"
              maxlength="7" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
            </el-radio>
          </el-col>
          <el-col :span="12">
            <el-radio label="2" :disabled="seeDisabled">
              固定比例 &nbsp;
              <el-input v-model="couponForm.commissionRate" placeholder="请输入比例" :disabled="couponForm.fixedProportion"
              maxlength="4" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
            </el-radio>
          </el-col>
        </el-radio-group>
      </el-form-item> -->
      
      <!-- <p class="stepTitle" style="margin-top:0">优惠券使用规则</p> -->

      <!-- <el-col :span="11">
        <el-form-item label="有效时间：" prop="effectiveTime">
          <el-date-picker type="datetimerange" v-model="couponForm.effectiveTime" @change="changeActiveTime"
            width="300px" align="right" value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptionsStart"/>
        </el-form-item>
      </el-col> -->

      <!-- <el-col :span="13" v-if="newType != 3 && (couponForm.brandTypeId != 0 && couponForm.brandId != 0)">
        <el-form-item label="是否适用于特价商品/套餐:" prop="isApplicable" label-width="210px">
            <el-checkbox v-model="couponForm.isApplicable"/>
        </el-form-item>
      </el-col> -->
      
    </el-form>
    <!-- :::::::::: 优惠券-操作按钮 :::::::::: -->
    <div style="text-align: center;margin: 10px 0;">
      <el-button @click="resetForm('couponForm')">{{ seeDisabled?'返回':'取消' }}</el-button>
      <el-button type="primary" class="search_btn" @click="saveCouponForm('couponForm')"
        v-if="seeSaveBtn == false" :loading="loadingBut">{{loadingButText}}</el-button>
      <el-button @click="resetTwo('couponForm')" style="display: none">重置</el-button>
    </div>
  </div>
  <!-- 特价商品 -->
  <div v-if="addShopType == 8">
    <div class="displayFlex">
      <el-card class="box-card card1" :style="'height:'+scrollbarHeight">
        <el-tree :data="oneData" ref="rightsTree" :props="defaultProps" node-key="id" highlight-current
        @node-click="handleNodeClick" :default-checked-keys="defaultCheckedKeys" class="lineheighttree"/>
      </el-card>
      <el-card class="box-card card2" :style="'height:'+scrollbarHeight">
        <div style="padding:0px 20px">
          <el-form :inline="true" style="display:flex;" class="findform">
            <!-- 顶部搜索框 -->
            <el-form-item label="商品名称" style="display:flex;width:60%">
              <el-input v-model="EnterpriseName" placeholder="请输入商品名称" maxlength="20"
                style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"/>
            </el-form-item>
            <el-form-item>
              <el-button type="danger" @click="onSubmit">查询</el-button>
            </el-form-item>
          </el-form>
        </div>

        <el-table :data="brandList" @selection-change="handleSelectionChange" 
        class="invoice_tab tabler_inner_container" stripe border style="height:auto;max-height:500px">
          <el-table-column type="selection" align="center" width="55"></el-table-column>
          <el-table-column label="序号" align="center" width="50">
            <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
          </el-table-column>
          <el-table-column label="商品名称" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.goodsname">{{scope.row.goodsname}}</span>
            </template>
          </el-table-column>
          <el-table-column label="商品类型" align="center">
            <template scope="scope">{{scope.row.goodstypename}}</template>
          </el-table-column>
          <el-table-column label="商品价格(元)" align="center">
            <template scope="scope">{{scope.row.price}}</template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <el-col :span="24" style="margin-top:15px;float:right" class="order_toolbar_footer">
          <el-pagination layout="prev, pager, next" @current-change="handleTabFive"
            :current-page="pageIndexFive" :page-size="10" :total="totalRowsCountFive"/>
        </el-col>
      </el-card>
    </div>
    <div style="width: 100%;margin: 15px auto;text-align: center;">
      <el-button @click="cancelActiveForm('addGoodsForm')">取消</el-button>
      <el-button type="danger" @click="addTjsp()">保存</el-button>
    </div>
  </div>
  <!-- 选择店铺 -->
  <el-dialog title="选择店铺" :visible.sync="dialogVisible" width="680px" height="422px">
    <el-row>
    <el-col :span="24">
      <el-form :inline="true">
        <!-- 顶部搜索框 -->
        <el-form-item>
          <el-input v-model="searchKey" placeholder="请输入关键词" style="width:230px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="getSortList" style="width:78px;background:#F56C6C">查询</el-button>
        </el-form-item>
      </el-form>
    </el-col>
    </el-row>
    <el-row class="shut">
      <el-col :span="12"> <div><p>店铺列表</p></div> </el-col>
      <el-col :span="12"> <div><p>选择店铺</p></div> </el-col>
    </el-row>
    <el-row class="shuttle">
      <el-col :span="12"></el-col>
      <div style="width:50%;float:left" class="TLeft">
        <p v-for="(val,index) in TData" @click="checkImg(val,index)" :key="index" v-show="val.name.indexOf(tempkey)>-1">
          <img :src="src1" v-if="alreadyChooseTemp.indexOf(val.id) < 0" class="left_img"/>
          <img :src="src2" v-else class="left_img" /> <span>{{val.name}}</span>
        </p>
      </div>
      <el-col :span="12" class="border_r">
        <div class="TRight" v-for="(item,index) in TData" v-show="alreadyChooseTemp.indexOf(item.id) >= 0" :key="index"> <p>{{item.name}}</p>
          <img src="../../assets/img/aicon36.png" @click="canCheck(item,index)" class="chahao"/>
        </div>
      </el-col>
    </el-row>
    <div slot="footer" class="dialog-footer" style="text-align: center;">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="danger" @click="confirmSetRole()">确 定</el-button>
    </div>
  </el-dialog>

  <!-- 播放视频 -->
  <el-dialog title='视频播放' :visible.sync="videoVisible" @close="closeVideo" width="30%" center>
    <video-player ref="videoPlayer" class="video-player vjs-custom-skin" :playsinline="true" :options="playerOptions"/>
  </el-dialog>
</section>
</template>
<script>
import { uploadOSS } from '../../utils/oss'; // oss上传视频
import wjEditor from '../../components/MyWangEditor';
import {getkind,getMerchantGoodsBrandTypeList} from "../../api/api";
import { getOssFile, uploadVedio } from '../../api/newOss';
import { getActivityExhibitionBrands, getSettingCommissionByBbIdAndGoodsBrandTypeId,
 getSelectGoodsByGoodCodeAndBbId, getEditSpecialOfferGoods, getEditSeckillGoods, getToStoreGiftBusiness,
 getEditGroupBuyGoods, getInsertActivityCoupon, getUpdateActivityCoupon, getEditReservationGoods,
 getBaseDataList, getSpecialOfferGoodsDetailById, getSeckillGoodsDetailById, getGroupBuyGoodsDetailById,
 getActivityCouponDetailById, getReservationGoodsDetailById, getActivityExibitionBrandsForBrandBusiness,
 postAddeditToStore, getToStoreGiftDetails, postAddeditContinuityOrder, getContinuityOrderDetails,
 getactivityshop, specialpriceGetgoods, specialpriceSavegoods } from "../../api/addActiviteForm";
export default {
  name: "addActiviteForm",
  components: { wjEditor },
    props: {
    activityTypeFrom: {
      type: Number,
      default: 1
    },
    whichRole:{
      type:Boolean,
      default:true
    }
  },
  data () {
    return {
     // 特价商品表单
      addActiveTitle: "新增/编辑活动",
      showStep: true,
      addShopType: 1, // 1:特价 2：秒杀  3：团购 4：优惠券  5：签到礼  6：到店打卡礼  7：连单礼  8：特价商品  9：幸运购  10：小标题
      addGoodsFormId:'',
      seeGoodBrand: "", // 商品品牌回显
      addGoodsForm: {
        goodBrand: "", //商品品牌
        
        // 参展品牌 (类别+品牌+店铺)
        goodsBrandTypeId: 0, // 二级品类
        brandId: 0,
        bbId: 0,

        goodModelCode: "", // 商品编码
        title: "", // 商品名称
        activityId: "", // 活动id
        commissionRate: 0, // 佣金比例
        marketPrice: "", // 市场价
        promotionPrice: "", // 促销价
        unit: '', // 单位
        seckillModeId: "", // 秒杀方式
        seckillPrice: "", // 秒杀价
        seckillDeposit: "", // 秒杀定金
        seckillStock: "", // 秒杀数量
        spikeDate: '', // 秒杀日期
        spikeTime: "", // 秒杀时间
        groupModeId: "", //拼团方式
        groupPrice: "", //团购价
        groupDeposit: "", //团购定金
        groupNumber: "", //成团人数
        tzrPrice: "", //甄惠装价
        stock: "", // 预约数量
        receiveDesc: '', // 领取说明
        writeOffDate: '', // 核销日期-日期时间段
        writeOffEndDate: '', // 核销结束日期
        writeOffBeginTime: '', // 核销开始时间
        writeOffEndTime: '', // 核销结束时间
        videoUrl: "", // 商品视频-切割之后链接
        coverImg: "", // 商品图片-切割之后路径
        advantageOne: "", // 商品优势1
        advantageTwo: "", // 商品优势2
        advantageThree: "", // 商品优势3
        
        productProfile: '', // 新版富文本 - 商品简介
        activityDesc: ``, // 新版富文本 - 活动说明
      },
      msriqiArr: [], // 秒杀日期
      hxriqiArr: [], // 时间段集合
      
      videoImg: '', // 视频封面图
      videoSrc: "", // 商品视频-全连接
      videoShortSrc: "", // 切割之后链接
      videoFlag: false, // 进度条显隐
      videoUploadPercent: 0, // 圆形进度条
      videoVisible: false, // 视频弹框
      playerOptions: {
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          src: "" // 视频url地址
        }],
        poster: '', // 你的封面地址
        width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },
      goodsImgUrl: "", // 商品图片

      optionExhibitions: [], // 商品品牌数据
      exhibitingBrands: [], // 获取活动店铺
      seebrandName: "", // 查看回显商品品牌
      couponForm: {
        // 所属品牌 (类别+品牌+店铺)
        brandTypeId: 0, // 二级品类
        brandId: 0,
        bbId: '', // 店铺
        name: "", //优惠券名称
        price: "", //优惠券售价
        
        faceValue: "", //优惠券面值
        number: "", // 发放数量

        commission: "", // 固定佣金
        fixedCommission: false, // 固定佣金 默认不置灰
        
        commissionRate: "", // 固定比例
        fixedProportion: true, // 固定比例  默认置灰


        disableThreshold: true, // 禁用输入框状态
        useThreshold: "", //有门槛时 满减的金额

        receiveDisable: false,
        receiveNumber: "", // 领取次数

        // effectiveTime: "", // 有效时间
        // isApplicable: false, // 是否使用特价商品/套餐
        
        specialInstructions: `<p>1、此优惠券适用于线上购买抵扣，也适用于线下的店铺消费抵扣。<br>
        2、秒杀、拼团类产品不参加<br>
        3、商家店铺或体验店购买商品并支付时请和导购提前沟通并确认购买商品是否可以使用此优惠券！<br>
        4、其他</p>`,
      },
      IsInterview: false, // 默认不选中
      seeDis: false, // 置灰
      commissionMode: '1', // 共创推广佣金
      hasThreshold: '0', //是否有使用门槛
      noLimit: false, // 领取次数无限制

      restaurants: [],
      danwei: [], // 单位
      secondKillModeList: [], // 秒杀方式
      groupTypeList: [], // 拼团方式
      // timeout: null,

      isdisabled: true,
      newSoid: "", // 列表选中行id
      PrimaryKeyId: "", // 活动优惠券主键id
      PrimaryKeyCouponId: "", // 优惠券id
      fill: false, // 判断是否有回填数据 默认false
      fillData: null,
      disabledFour: false, // 编辑禁用 默认不禁用 false
      // 控制活动时间不能小于当前时间
      // pickerOptionsStart: {
      //   disabledDate(time) {
      //     return (
      //       time.getTime() < new Date(new Date().toLocaleDateString()).getTime()
      //     );
      //   },
      // },
      seeFormType: "", // 查看标识
      seeDisabled: false, // 默认不禁用
      seeSaveBtn: false, // 保存按钮
      newType: '', // 活动类型: 1平台 2品牌建材 3装修公司 4联盟活动
      journalArr: [], // 礼品名称&礼品图片 - 集合
      anwser: '', // 礼品名称
      detailImgUrlarr: '', // 礼品图片
      liandanshul: '', // 连单数量
      meidanjine: '', // 每单金额
      dddklGzsm: `1.点击“立即报名”即可参与到店打卡有礼活动；
2.使用微信扫一扫店铺码即为打卡成功，打卡店铺不分先后；
3.活动截止日前完成所有活动店铺的打卡即可获得礼品；
4.点击“返现码-核销码-打卡礼”，出示打卡礼核销码，由活动举办方员工扫码核销，现场领取礼品。`,
      ldlGzsm: `1.在活动期间，客户消费X单，且每单大于X元即可兑换x联单礼品；
2.客户退单或减项后不满足原礼品的兑换条件，应退还原礼品。`,
      
      loadingBut: false,
      loadingButText: '确定',
      
      dialogVisible: false, // 选择店铺-弹框
      searchKey: "",
      tempkey: "",
      TData: [], // 店铺全部
      alreadyChoose: [], // 已选择 店铺id 集合
      alreadyChooseTemp: [], // 已选择 店铺id 集合-临时
      src1: require("../../assets/img/aicon13.png"), // 未选
      src2: require("../../assets/img/aicon10.png"), // 已选
      
      // 特价商品
      scrollbarHeight: '',
      // 树形控件
      oneData: [],
      defaultProps: {
        label: 'name',
        children: 'node',
      },
      defaultCheckedKeys: [],     //树形控件默认选中数组
      EnterpriseName: "", // 企业名称
      brandList: [],  // 特价商品详情选择列表
      pageIndexFive: 1,   // 分页
      totalRowsCountFive: 0, // 列表总数
      groupWorkArr: [],   // 选中的数组
      lmid: '', // 联盟id
      dpid: '', // 店铺id
    }
  },
  mounted() {
    this.scrollbarHeight = document.documentElement.clientHeight * 0.7 + "px"
    window.onresize = () => {
      if (this.scrollbarHeight) this.scrollbarHeight = document.documentElement.clientHeight * 0.7 + "px"
    };
  },
  watch: {
    // 监听共创推广佣金: 固定佣金 & 固定比例
    'commissionMode'(newV,oldV) {
      if(this.commissionMode == '1') {
        this.couponForm.commissionRate = "";
        this.couponForm.fixedProportion = true;
        this.couponForm.fixedCommission = false;
      } else {
        this.couponForm.commission = "";
        this.couponForm.fixedCommission = true;
        this.couponForm.fixedProportion = false;
      }
    },
    // 监听使用门槛
    'hasThreshold'(nv,ov) {
      if(this.hasThreshold == '1') {
        this.couponForm.disableThreshold = false;
      } else {
        this.couponForm.disableThreshold = true;
        this.couponForm.useThreshold = "";
      }
    },
    // 监听秒杀定金 - 价格
    'addGoodsForm.seckillModeId'(nv,ov) {
      this.addGoodsForm.seckillModeId == 2 ? this.addGoodsForm.seckillDeposit : this.addGoodsForm.seckillDeposit = 0;
    },
    'defaultCheckedKeys':function(newVal, oldVal) {
      if(newVal){
        this.$nextTick(() => {
          document.querySelector('.el-tree-node__content').click()
        })
      }
    }
  },
  created() {
    // let shijianqj = this.$cookie.get("timeInterval");
    
    // let shijianqj = JSON.parse(window.localStorage.getItem('timeInterval'));
    // let linshiqj = [];
    // shijianqj.map(item => {
    //   let treeControlData = {Id:item,Name:item}
    //   linshiqj.push(treeControlData);
    // })
    // this.msriqiArr = linshiqj.reverse(); // 赋值时间区间改造后集合 并设置倒序
    // this.msriqiArr.push({ Id: 0, Name: "每天", })
    // this.hxriqiArr = linshiqj.reverse(); // 赋值时间区间改造后集合 并设置倒序
    
    // let shijianqj = JSON.parse(window.localStorage.getItem('timeInterval'));
    // let linshiqj = shijianqj.map(item => {return {Id:item,Name:item}})
    // this.msriqiArr = [{ Id: 0, Name: "每天", }].concat(linshiqj); 
    // this.hxriqiArr = [].concat(linshiqj);

    let shijianqj = JSON.parse(window.localStorage.getItem('timeInterval'));
    let linshiqj = shijianqj.map(item => {return {Id:item,Name:item}}).reverse();
    let hexiaoTime = shijianqj.map(item => {return {Id:item,Name:item}}); // 核销时间
    this.msriqiArr = [{ Id: '每天', Name: "每天", }].concat(linshiqj);
    this.hxriqiArr = [].concat(hexiaoTime);

  },
  methods: {
    // 初始化
    initComponent(val,activityTypeFrom,soId,sponsorType,see){
      this.lmid = localStorage.getItem("lianmengId");
      this.dpid = localStorage.getItem("dpid"); // 店铺id
      this.addGoodsFormId = val; // 活动id
      this.addShopType = activityTypeFrom; // 活动形式类型
      this.newSoid = soId; // 选中行id
      this.newType = sponsorType; // 活动类型
      this.seeFormType = see; // 查看并禁用表单
      this.eventStore(); // 获取活动店铺
      // 判断新增进来的还是编辑进来的
      if(this.newSoid) { // 编辑并回显
        this.disabledFour = true;
        // 特价回显接口
        if(this.addShopType == 1) {
          let addParams = {
            specialOfferGoodsId: this.newSoid // 特价商品列表id
          };
          getSpecialOfferGoodsDetailById(addParams).then((data) => {
            this.addGoodsForm = data.ResultObj;
            this.addGoodsForm.goodBrand = [this.addGoodsForm.goodsBrandTypeId,this.addGoodsForm.brandId,this.addGoodsForm.bbId];
            this.seeGoodBrand = this.addGoodsForm.brandName; // 商品品牌回显
            this.goodsImgUrl =data.ResultObj.coverImg;
            this.addGoodsForm.coverImg = this.addGoodsForm.relativePathCoverImg;
          });
        }
        // 秒杀回显接口
        if(this.addShopType == 2) {
          let addParams = {
            seckillGoodsId: this.newSoid // 秒杀商品主键id
          };
          getSeckillGoodsDetailById(addParams).then((data) => {
            this.addGoodsForm = data.ResultObj;
            this.couponForm = data.ResultObj;
            this.seeGoodBrand = this.addGoodsForm.brandName; // 商品品牌回显
            this.videoSrc = data.ResultObj.videoUrl?localStorage.BaseOssUrl + data.ResultObj.videoUrl:''; // 拼接协议头 + 商品视频
            this.addGoodsForm.videoUrl = data.ResultObj.videoUrl?localStorage.BaseOssUrl + data.ResultObj.videoUrl:''; // 商品视频
            this.goodsImgUrl = data.ResultObj.coverImg; // 商品图片
            this.addGoodsForm.coverImg = this.addGoodsForm.relativePathCoverImg;
            this.addGoodsForm.seckillModeId = Number(this.addGoodsForm.seckillModeId); // 字符串转数字
            if(this.couponForm.bbId) {
              this.addGoodsForm.goodBrand = [this.addGoodsForm.goodsBrandTypeId,this.addGoodsForm.brandId];
              this.getBrandByCityId(); // 调用商品品牌
            }
          });
        }
        // 团购回显接口
        if(this.addShopType == 3) {
          let addParams = {
            groupBuyId: this.newSoid // 团购商品主键id
          };
          getGroupBuyGoodsDetailById(addParams).then((data) => {
            this.addGoodsForm = data.ResultObj;
            this.couponForm = data.ResultObj;
            this.seeGoodBrand = this.addGoodsForm.brandName; // 商品品牌回显
            this.videoSrc = data.ResultObj.videoUrl?localStorage.BaseOssUrl + data.ResultObj.videoUrl:''; // 拼接协议头 + 商品视频
            this.addGoodsForm.videoUrl = data.ResultObj.videoUrl?localStorage.BaseOssUrl + data.ResultObj.videoUrl:''; // 商品视频
            this.goodsImgUrl = data.ResultObj.coverImg; // 商品图片
            this.addGoodsForm.coverImg = this.addGoodsForm.relativePathCoverImg;
            this.addGoodsForm.groupModeId = Number(this.addGoodsForm.groupModeId); // 字符串转数字
            if(this.couponForm.bbId) {
              this.addGoodsForm.goodBrand = [this.addGoodsForm.goodsBrandTypeId,this.addGoodsForm.brandId];
              this.getBrandByCityId(); // 调用商品品牌
            }
          });
        }
        // 优惠券回显接口
        if(this.addShopType == 4) {
          // this.getprovince(); // 调用商品品牌
          let addParams = {
            couponId: this.newSoid // 活动优惠券主键id
          };
          getActivityCouponDetailById(addParams).then((data) => {
            this.couponForm = data.ResultObj;
            // if(this.whichRole && !this.seeFormType) {
            //   this.couponForm.brandName = [this.couponForm.brandTypeId,this.couponForm.brandId,this.couponForm.bbId];
            // } else {
            //   this.couponForm.brandName = [this.couponForm.brandTypeId,this.couponForm.brandId];
            //   this.seebrandName = this.couponForm.brandName; // 优惠券查看回显商品品牌
            // }
            this.PrimaryKeyId = this.couponForm.id; // 活动优惠券主键id
            this.PrimaryKeyCouponId = this.couponForm.couponId; // 优惠券id
            // 判断回显售价
            if(this.couponForm.price == 0) {
              this.IsInterview = true; // 复选框 false 默认不选中  true 为选中
              this.couponForm.price = ""; // 清空输入框内容并
              this.seeDis = true; // 置灰输入框
            }

            // 判断回显共创推广佣金
            if(this.couponForm.commissionMode == '1') {
              this.commissionMode = '1';
              this.couponForm.commissionRate = "";
              this.couponForm.fixedProportion = true;
              this.couponForm.fixedCommission = false;
            }
            if(this.couponForm.commissionMode == '2') {
              this.commissionMode = '2';
              this.couponForm.commission = "";
              this.couponForm.fixedCommission = true;
              this.couponForm.fixedProportion = false;
            }
            
            // 判断使用门槛
            if(this.couponForm.useThreshold == 0) {
              this.hasThreshold = '0';
              this.couponForm.disableThreshold = true;
              this.couponForm.useThreshold = "";
            } else {
              this.hasThreshold = '1';
            }
            // 判断领取数量
            if(this.couponForm.receiveNumber == 0) {
              this.noLimit = true; // 复选框 false 默认不选中  true 为选中
              this.couponForm.receiveNumber = ""; // 清空输入框内容并
              this.couponForm.receiveDisable = true; // 置灰输入框
            }
          });
        }
        // 预约签到礼回显接口
        if(this.addShopType == 5) {
          let addParams = {
            reservationGoodsId: this.newSoid // 预约签到礼商品列表id
          };
          getReservationGoodsDetailById(addParams).then(data => {
            
            this.addGoodsForm = data.ResultObj;
            // this.addGoodsForm.goodBrand = [this.addGoodsForm.goodsBrandTypeId,this.addGoodsForm.brandId,this.addGoodsForm.bbId];
            // this.seeGoodBrand = this.addGoodsForm.brandName; // 商品品牌回显
            // this.goodsImgUrl = data.ResultObj.coverImg;
            // this.addGoodsForm.coverImg = this.addGoodsForm.relativePathCoverImg;
            this.journalArr = this.addGoodsForm.coverImg.map(item => {
              return {
                name: item.name,
                imgUrl: item.imgUrl.replace('', localStorage.BaseOssUrl)
              }
            }); // 礼品集合
          });
        }
        // 到店打卡礼 - 回显接口
        if(this.addShopType == 6) {
          let addParams = {
            id: this.newSoid // 到店打卡礼列表id
          };
          getToStoreGiftDetails(addParams).then(data => {
            let newDddkl = data.resultObj;
            this.newSoid = newDddkl.id; // 礼品id
            this.addGoodsFormId = newDddkl.activityId; // 活动id
            this.addGoodsForm.stock = newDddkl.number; // 礼品数量
            this.dddklGzsm = newDddkl.desc; // 规则说明
            this.journalArr = newDddkl.imgUrls.map(item => {
              return {
                name: item.name,
                imgUrl: item.imgUrl.replace('', localStorage.BaseOssUrl)
              }
            }); // 礼品集合
            // this.alreadyChoose = newDddkl.bbIds; // 活动参与店铺集合（此活动所有参与的店铺）
            this.TData = newDddkl.bbIds || [];
            this.TData.forEach(el => {
              if (el.isHave == 1) {
                this.alreadyChoose.push(el.id);
              }
            });
          });
        }
        // 连单礼 - 回显接口
        if(this.addShopType == 7) {
          let addParams = {
            id: this.newSoid // 连单礼列表id
          };
          getContinuityOrderDetails(addParams).then((data) => {
            let newLdl = data.resultObj;
            this.seeGoodBrand = newLdl.id; // 礼品id
            this.goodsImgUrl = newLdl.activityId; // 活动id
            this.addGoodsForm.stock = newLdl.number; // 礼品数量
            this.journalArr = newLdl.imgUrls.map(item => {
              return {
                name: item.name,
                imgUrl: item.imgUrl.replace('', localStorage.BaseOssUrl)
              }
            }); // 礼品集合
            this.liandanshul = newLdl.continuityOrderNumber; // 连单数量
            this.meidanjine = newLdl.orderPrice; // 每单金额
            this.ldlGzsm = newLdl.desc; // 规则说明
          });
        }

      } else { // 新增进来的 清空数据
        // this.getprovince(); // 调用商品品牌
        if(this.couponForm.bbId || this.dpid) {
        this.getBrandByCityId(); // 调用商品品牌
        }
        this.disabledFour = false;
        this.addGoodsForm.productProfile = "";
        this.addGoodsForm.activityDesc = "";
        this.couponForm.specialInstructions = "";
        if(this.addShopType != 4) {
          this.resetOne();
          this.addGoodsForm.marketPrice = ""; // 市场价
          this.addGoodsForm.seckillStock = ""; // 数量
          this.addGoodsForm.spikeDate = ''; // 秒杀日期
          this.addGoodsForm.spikeTime = ""; // 秒杀时间
          this.videoSrc = ""; // 清空店铺视频
          this.journalArr = []; // 清空集合
          this.anwser = '';
          this.detailImgUrlarr = '';
          if(this.addShopType == 6) {
            this.dianpuList(); // 店铺列表
          }
          this.brandTypeTree(); // 特价商品-树列
        } else {
          this.resetTwo();
        }
      }
      if(this.addShopType != 4) {
        this.getdanwei(); // 查询单位
        this.secondKillMode(); // 秒杀方式
        this.theWayOfCombining(); // 拼团方式
      }
      
      // 判断如果是审核商家活动形式点击查看进来的
      if(this.seeFormType == 3) {
        // 置灰并禁用所有表单输入框
        this.disabledFour = true;
        this.seeDis = true;
        this.seeDisabled = true; // 查看禁用
        this.seeSaveBtn = true; // 按钮消失
      }
    },
    // 重置表单
    resetOne(addGoodsForm) {
      this.$nextTick(()=>{
        this.$refs.addGoodsForm.resetFields();
      })
    },
    // 重置优惠券表单
    resetTwo(couponForm) {
      this.$nextTick(()=>{
        this.$refs.couponForm.resetFields();
      })
    },
    // 请选择商品品牌
    handleChange(val) {
      this.addGoodsForm.goodsBrandTypeId = val[0];
      this.addGoodsForm.brandId = val[1];
      this.addGoodsForm.bbId = val[2];
      // 只有秒杀&团购时才走查询佣金接口
      if(this.addShopType == 2 || this.addShopType == 3) {
        let obj = {
          activityId: this.addGoodsFormId, // 活动id
          activityFormId: this.addShopType, // 活动形式id
          goodsBrandTypeId: this.addGoodsForm.goodsBrandTypeId // 活动品类id
        };
        getSettingCommissionByBbIdAndGoodsBrandTypeId(obj).then(data => {
          this.fill = false;
          if(data.ResultCode == 1) {
            // 填充数据
            this.fill = true;
            this.fillData = data.ResultObj;
            this.addGoodsForm.commissionRate = data.ResultObj.commissionRate; // 佣金比例
          }
          if(data.ResultCode == 4) {
            data.ResultObj == null ? "" : "";
            this.fill = false;
          }
        })
      }
    },
    
    // 优惠券 请选择所属品牌
    handleChangeYhq(val) {
      this.couponForm.brandTypeId = val[0];
      this.couponForm.brandId = val[1];
      this.couponForm.bbId = val[2];
    },
    // 获取活动参展品牌商三级联动数据
    getprovince() {
      // 平台-活动
      if(this.whichRole && !this.seeFormType) {
        var loginParams = {
          activityId: this.addGoodsFormId, // 活动id
          fromId: this.addShopType
        };
        getActivityExhibitionBrands(loginParams).then((data) => {
          let that = this;
          let exhibitionBrand = [];
          data.ResultObj.map((item) => {
            // 一级
            let provinceData = { value: item.id, label: item.name, children: [] };
            exhibitionBrand.push(provinceData);
            // 二级
            item.BDAcivityExhibitionBrands.map((secondLevel) => {
              let cityData = { value: secondLevel.id, label: secondLevel.name, children: [] };
              provinceData.children.push(cityData);
              // 三级
              secondLevel.BDAcivityExhibitionBrandBusinesses.map((threeLevels) => {
                cityData.children.push({ value: threeLevels.id, label: threeLevels.name });
              });
            });
          });
          that.optionExhibitions = exhibitionBrand;
        });
      } else {
        var loginParams = {
          bbId: localStorage.BbId // 商家id
        };
        getActivityExibitionBrandsForBrandBusiness(loginParams).then((data) => {
          let that = this;
          let exhibitionBrand = [];
          data.ResultObj.map((item) => {
            // 一级
            let provinceData = { value: item.id, label: item.name, children: [] };
            exhibitionBrand.push(provinceData);
            // 二级
            item.BDAcivityExhibitionBrands.map((secondLevel) => {
              let cityData = { value: secondLevel.id, label: secondLevel.name };
              provinceData.children.push(cityData);
            });
          });
          that.optionExhibitions = exhibitionBrand;
        });
      }
    },
    // 获取活动店铺
    eventStore() {
      this.dpid==null?0:this.dpid
      let obj = {
        activityId: this.addGoodsFormId, // 活动ID，默认0（注：activityId和maId必须传一个）
        maId: this.lmid?this.lmid:0, // 联盟ID，默认0（注：activityId和maId必须传一个，传联盟ID则查联盟下的所有店铺）
        statusId: 1, // 状态 1=开启，2=关闭、3=过期（注：默认1，传0查全部状态)
        shopId: this.dpid?this.dpid:0, // 店铺ID
      };
      getactivityshop(obj).then(data => {
        if (data.resultCode == 1) {
          this.exhibitingBrands = data.resultObj;
          if(this.addShopType == 4) {
            this.exhibitingBrands.unshift({
              id: 0,
              name: "全部",
            });
          }
        }
      })
    },
    // 获取单位数据
    getdanwei() {
      let that = this;
      var loginParams = {
        tableName: "tBDUnit",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
        that.danwei = data.ResultObj;
        that.danwei.unshift({
          Id: 0,
          Name: "请选择"
        });
      })
    },
    // 秒杀方式
    secondKillMode() {
      var loginParams = {
        tabName: "tBDSeckillMode"
      };
      getBaseDataList(loginParams).then(data => {
        this.secondKillModeList = data.ResultObj;
      })
    },
    // 拼团方式
    theWayOfCombining() {
      var loginParams = {
        tabName: "tBDGroupMode"
      };
      getBaseDataList(loginParams).then(data => {
        this.groupTypeList = data.ResultObj;
      })
    },
    // 礼品图片
    lpPucUpload(file) {
      // 判断图片格式
      const isJPG = file.type === 'image/png' || file.type === 'image/jpg' ||file.type === 'image/jpeg';
      // 判断图片大小
      const isLt2M = file.size / 1024 / 1024 <= 5;
      if (!isJPG) {
        this.$swal({
          type: "warning",
          text: "上传图片只支持jpg、png等格式!"
        });
        return;
      }
      if (!isLt2M) {
        this.$swal({
          type: "warning",
          text: "上传图片大小不能超过 5MB!"
        });
        return;
      }
      // if (this.detailImgUrlarr == '') {
      //   this.$swal({
      //     type: "warning",
      //     text: "请上传 1 张图片"
      //   });
      //   return false;
      // }
      var _this = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function(e) {
        // oss 直传图片
        let obj = { type: 11 };
        getOssFile(obj).then(data => {
          if (data.resultCode == 1) {
            let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
            let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
            let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
            let ossfile = data.resultObj.directory; // 保存路径
            let ossbucket = data.resultObj.bucket; // bucket
            localStorage.setItem('keyossId',ossId);
            localStorage.setItem('keyossSecret',ossSecret);
            localStorage.setItem('keyossHost',ossHost);
            localStorage.setItem('keyossfile',ossfile);
            localStorage.setItem('keyossbucket',ossbucket);
            uploadOSS(file,0).then(data => {
              _this.detailImgUrlarr = data;
            })
            
          }
        })
      };
    },
    // 上传店铺视频
    handleFile(file) {
      if (file.size > 50*1024 * 1024) {
        this.$swal({
          type:"warning",
          text:"请上传小于50MB的视频"
        })
        return false;
      }
      if (file.type.indexOf("mp4") == -1) {
        this.$swal({
          type:"warning",
          text:"请上传mp4格式的视频"
        })
        return false;
      }
      // 正在上传视频中，请稍后再试
      this.loadingBut = true;
      this.loadingButText = '上传中...';
      this.videoFlag = true;
      this.videoUploadPercent = 0;
      this.timer = setInterval(() => {
        if (this.videoUploadPercent >= 99) {
          clearInterval();
          return;
        }
        this.videoUploadPercent += 1;
      }, 50);
      this.videoSrc = "";
      // oss 获取上传探店视频参数
      let obj2 = new FormData();
      obj2.append('file',file);
      if(this.addShopType == 2){
        var source = 11;
      }
      if(this.addShopType == 3){
        var source = 12;
      }
      // 上传视频获取路径
      uploadVedio(obj2, source).then(data => {
        if (data.resultCode == 1) {
          this.videoImg = localStorage.BaseOssUrl + data.resultObj.r_png; // 视频封面图
          this.videoSrc = localStorage.BaseOssUrl + data.resultObj.r_m3u8;
          this.addGoodsForm.videoUrl = this.videoSrc.replace(localStorage.BaseOssUrl,'');
          this.loadingBut = false;
          this.loadingButText = '确定';
          this.videoFlag = false;
          this.videoUploadPercent = 0;
        } else {
          this.$swal({
            type:'error',
            text: data.resultMsg,
          })
          this.videoFlag = false;
          this.videoUploadPercent = 0;
        }
      })
    },
    // 新版本上传oss预览
    newSeevideo(){
      if(this.videoSrc.indexOf("blob:") != -1){
        window.open(this.videoSrc);
      }else{
        this.palySeevideo(this.videoSrc);
      }
    },
    // 播放视频
    palySeevideo(url){
      this.videoVisible = true;
      this.playerOptions.sources[0].src = url;
    },
    closeVideo() {
      this.$refs.videoPlayer.player.pause();
    },
    // 删除视频操作
    delvideo() {
      this.$swal({
        type: "warning",
        text: "重要信息，确认删除视频吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          this.videoImg='';
          this.videoSrc='';
          this.videoShortSrc='';
          // videoUrl.sources[0].src = ''
          // videoUrl.poster = ''
        }
      }).catch(() => {
        return;
      });
    },
    // 售价 选中免费 :: 清空输入框
    mianfei() {
      if (this.IsInterview == true) {
        this.couponForm.price = "";
        this.seeDis = true; // 置灰输入框
      }
      if(this.IsInterview == false) {
        this.seeDis = false; // 解开置灰输入框
      }
    },
    // 选中无限制
    unlimited() {
      if (this.noLimit == true) {
        this.couponForm.receiveNumber = "";
        this.couponForm.receiveDisable = true; // 置灰输入框
      }
      if (this.noLimit == false) {
        this.couponForm.receiveDisable = false; // 解开置灰输入框
      }
    },
    // 活动时间转换
    // changeActiveTime(time) {
    //   this.startTime = time[0];
    //   this.endTime = time[1];
    // },
    // 特殊说明
    contentChangeThree(content) {
      this.couponForm.specialInstructions = content;
    },
    // 商品简介
    contentChangeOne(content) {
      this.addGoodsForm.productProfile = content
      console.log(this.addGoodsForm.productProfile, '商品简介');
    },
    // 活动说明
    contentChangetWO(content) {
      this.addGoodsForm.activityDesc = content
      console.log(this.addGoodsForm.activityDesc, '活动说明');
    },
    // 商品编码联想接口
    querySearchAsync(queryString, cb) {
      let addParams = {
        bbId: this.couponForm.bbId ? this.couponForm.bbId : this.dpid, // 店铺id
        brandId: this.addGoodsForm.brandId, // 品牌id
        goodsCode: this.addGoodsForm.goodModelCode, // 商品编码
      };
      getSelectGoodsByGoodCodeAndBbId(addParams).then((data) => {
        // if(data.ResultCode == 1) {
        //   this.restaurants = data.ResultObj;
        //   var results = queryString ? this.restaurants.filter(this.createStateFilter(queryString)) : this.restaurants;
        //   clearTimeout(this.timeout);
        //   this.timeout = setTimeout(() => {
        //     cb(results);
        //   }, 3000 * Math.random());
        // }
        if(data.ResultCode == 1) {
          this.restaurants = data.ResultObj;
          var results = queryString ? this.restaurants.filter(this.createStateFilter(queryString)) : this.restaurants;
          cb(results);
        }
        if(data.ResultCode == 4) {
          this.restaurants = [];
          var results = queryString ? this.restaurants.filter(this.createStateFilter(queryString)) : this.restaurants;
          cb(results);
        }
      });
    },
    createStateFilter(queryString) {
      return (state) => {
        return ( state.value.indexOf(queryString) >= 0 );
      };
    },
    // 商品编码
    handleSelect(item) {
      // 填充数据
      this.addGoodsForm.marketPrice = item.marketPrice; // 市场价
      this.addGoodsForm.tzrPrice = item.tzrPrice; // 甄惠装价
      this.addGoodsForm.goodModelCode = item.goodModelCode; // 商品编码
      this.addGoodsForm.title = item.title; // 商品名称
      this.goodsImgUrl = item.coverImg; // 封面图片 全连接
      this.addGoodsForm.coverImg = item.relativePathCoverImg; // 封面图片 截取之后的链接
      this.addGoodsForm.advantageOne = item.advantageOne; // 亮点1
      this.addGoodsForm.advantageTwo = item.advantageTwo; // 亮点2
      this.addGoodsForm.advantageThree = item.advantageThree; // 亮点3
      this.addGoodsForm.productProfile = item.introduce; // 商品简介
      this.videoSrc = item.videoUrl; // 商品视频 - 全路径
      this.addGoodsForm.unit = item.unit; // 单位
    },
    // 商品图片
    beforeAvatarUpload(file) {
      const isSize = new Promise(function (resolve, reject) {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = function() {
          // let valid = img.width == width && img.height == height;
          let valid = img.width / img.height == 1; // 控制传正方形图片
          valid ? resolve() : reject();
        };
      }).then(() => {
          var that = this;
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = async function (e) {
            /* oss 直传图片 */
            var obj = {type: 11};
            getOssFile(obj).then(data => {
              if (data.resultCode == 1) {
                let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
                let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
                let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
                let ossfile = data.resultObj.directory; // 保存路径
                let ossbucket = data.resultObj.bucket; // bucket
                localStorage.setItem('keyossId',ossId);
                localStorage.setItem('keyossSecret',ossSecret);
                localStorage.setItem('keyossHost',ossHost);
                localStorage.setItem('keyossfile',ossfile);
                localStorage.setItem('keyossbucket',ossbucket);
                
              }
            })
            var newOssPic = await uploadOSS(file,0);
            that.goodsImgUrl = newOssPic;
            that.addGoodsForm.coverImg = newOssPic.replace(localStorage.BaseOssUrl,'')

          };
          if (that.imgarr.length >= 1) {
            that.isdisabled = false;
          }
          return file;
        },() => {
          this.$swal({
            type: "warning",
            text: "上传的图片必须是宽高比例为1:1",
          });
          return Promise.reject();
      });
      return isSize;
    },
    // 取消返回活动形式列表
    cancelActiveForm() {
    //   this.$refs.addGoodsForm.resetFields();
      this.$emit('cancelActiveForm',2,this.addShopType,this.newType)
    },
    // 优惠券 取消
    resetForm() {
    //   this.$refs.addGoodsForm.resetFields();
      this.$emit('cancelActiveForm',2,this.addShopType,this.newType)
    },
    // 市场价输入规则
    changeblur() {
      this.addGoodsForm.marketPrice = String(this.addGoodsForm.marketPrice)
        .replace(/^(\s+|\.+|\D)/, "")
        .replace(/(\d+)(\.)(\d)(\.)/, "$1$2$3")
        .replace(/(\d+)(\.)(\.)/, "$1$2")
        .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      this.addGoodsForm.promotionPrice = String(
        this.addGoodsForm.promotionPrice
      )
        .replace(/^(\s+|\.+|\D)/, "")
        .replace(/(\d+)(\.)(\d)(\.)/, "$1$2$3")
        .replace(/(\d+)(\.)(\.)/, "$1$2")
        .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      this.addGoodsForm.seckillPrice = String(this.addGoodsForm.seckillPrice)
        .replace(/^(\s+|\.+|\D)/, "")
        .replace(/(\d+)(\.)(\d)(\.)/, "$1$2$3")
        .replace(/(\d+)(\.)(\.)/, "$1$2")
        .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      this.addGoodsForm.seckillDeposit = String(
        this.addGoodsForm.seckillDeposit
      )
        .replace(/^(\s+|\.+|\D)/, "")
        .replace(/(\d+)(\.)(\d)(\.)/, "$1$2$3")
        .replace(/(\d+)(\.)(\.)/, "$1$2")
        .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      this.addGoodsForm.groupPrice = String(this.addGoodsForm.groupPrice)
        .replace(/^(\s+|\.+|\D)/, "")
        .replace(/(\d+)(\.)(\d)(\.)/, "$1$2$3")
        .replace(/(\d+)(\.)(\.)/, "$1$2")
        .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      this.addGoodsForm.groupDeposit = String(this.addGoodsForm.groupDeposit)
        .replace(/^(\s+|\.+|\D)/, "")
        .replace(/(\d+)(\.)(\d)(\.)/, "$1$2$3")
        .replace(/(\d+)(\.)(\.)/, "$1$2")
        .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      this.addGoodsForm.tzrPrice = String(
        this.addGoodsForm.tzrPrice
      )
        .replace(/^(\s+|\.+|\D)/, "")
        .replace(/(\d+)(\.)(\d)(\.)/, "$1$2$3")
        .replace(/(\d+)(\.)(\.)/, "$1$2")
        .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
    },
    // 保存优惠券内容
    saveCouponForm(){
      // if (this.couponForm.brandName == "") {
      //   this.$swal({
      //     type: "warning",
      //     text: "请选择所属品牌",
      //   });
      //   return false;
      // }
      if (!this.couponForm.name) {
        this.$swal({
          type: "warning",
          text: "请输入优惠券名称",
        });
        return false;
      }
      // 判断售价 如果没有选中免费
      if (this.IsInterview == false) {
        if (!this.couponForm.price) {
          this.$swal({
            type: "warning",
            text: "请输入优惠券售价",
          });
          return false;
        }
        if (this.couponForm.price < 1 || this.couponForm.price > 9999999) {
          this.$swal({
            type: "warning",
            text: "请输入优惠券售价,范围应在 1～9999999",
          });
          return false;
        }
      } else {
        this.IsInterview = true;
        this.couponForm.price = "";
      }

      // 判断面值
      if (!this.couponForm.faceValue) {
        this.$swal({
          type: "warning",
          text: "请输入优惠券面值",
        });
        return false;
      }
      if (this.couponForm.faceValue < 1 || this.couponForm.faceValue > 9999999 ) {
        this.$swal({
          type: "warning",
          text: "请输入优惠券面值,范围应在 1～99999999",
        });
        return false;
      }
      // 判断优惠券数量
      if (!this.couponForm.number) {
        this.$swal({
          type: "warning",
          text: "请输入数量",
        });
        return false;
      }
      if (this.couponForm.number < 1 || this.couponForm.number > 9999999 ) {
        this.$swal({
          type: "warning",
          text: "请输入数量,范围应在 1～99999999",
        });
        return false;
      }

      // if(this.commissionMode == '1') {
      //   if (this.couponForm.commission === "") {
      //     this.$swal({
      //       type: "warning",
      //       text: "请输入推广佣金金额",
      //     });
      //     return false;
      //   }
      //   if(!this.IsInterview) {
      //     if (this.couponForm.commission < 0 || this.couponForm.commission > Number(this.couponForm.price) ) {
      //       this.$swal({
      //         type: "warning",
      //         text: `请输入推广佣金金额,范围应在 0～${this.couponForm.price}`,
      //       });
      //       return false;
      //     }
      //   }
      // } else {
      //   if (!this.couponForm.commissionRate) {
      //     this.$swal({
      //       type: "warning",
      //       text: "请输入推广佣金比例",
      //     });
      //     return false;
      //   }
      //   if (this.couponForm.commissionRate < 0 || this.couponForm.commissionRate > 99.99 ) {
      //     this.$swal({
      //       type: "warning",
      //       text: "请输入推广佣金比例,范围应在 0～99.99%",
      //     });
      //     return false;
      //   }
      // }

      // 如果售价选中的是免费 共创推广佣金金额也必须为0
      if (this.IsInterview && this.couponForm.commission > 0) {
        this.$swal({
          type: "warning",
          text: "售价为0时 推广佣金金额也必须为0",
        });
        return false;
      }
      // 如果售价选中的是免费 共创推广佣金比例也必须为0
      if (this.IsInterview && this.couponForm.commissionRate > 0) {
        this.$swal({
          type: "warning",
          text: "售价为0时 推广佣金比例也必须为0",
        });
        return false;
      }
      
      if(this.hasThreshold == '1') {
        if (!this.couponForm.useThreshold) {
          this.$swal({
            type: "warning",
            text: "请输入使用门槛金额",
          });
          return false;
        }
        if (this.couponForm.useThreshold < 1 || this.couponForm.useThreshold > 9999999 ) {
          this.$swal({
            type: "warning",
            text: "请输入使用门槛金额,范围应在 1～99999999",
          });
          return false;
        }
      }
      
      if (!this.noLimit) {
        if (!this.couponForm.receiveNumber) {
          this.$swal({
            type: "warning",
            text: "请输入每人可领取数量",
          });
          return false;
        }
        if (this.couponForm.receiveNumber < 1 || this.couponForm.receiveNumber > 9999999 ) {
          this.$swal({
            type: "warning",
            text: "每人可领取数量,范围应在 1～99999999",
          });
          return false;
        }
      }
      
      // if (!this.couponForm.effectiveTime) {
      //   this.$swal({
      //     type: "warning",
      //     text: "请选择有效时间",
      //   });
      //   return false;
      // }
      // if (!this.couponForm.isApplicable) {
      //   this.$swal({
      //     type: "warning",
      //     text: "请选择是否适用于特价商品/套餐",
      //   });
      //   return false;
      // }
      if (!this.couponForm.specialInstructions) {
        this.$swal({
          type: "warning",
          text: "请输入优惠券特殊说明",
        });
        return false;
      }
      this.loadingBut = true;
      this.loadingButText = '提交中...';
      // 编辑修改优惠券
      if(this.newSoid) {
        let couponForm = JSON.parse(JSON.stringify(this.couponForm));
        let addParams = {
          id: this.PrimaryKeyId, // 活动优惠券主键
          brandTypeId: this.couponForm.brandTypeId, // 品类id
          brandId: this.couponForm.brandId, // 品牌id
          bbId: this.couponForm.bbId ? this.couponForm.bbId : this.dpid, // 店铺id
          number: this.couponForm.number, // 发放数量
          commissionMode: this.commissionMode == '1' ? '1' : '2', // 佣金类型1=固定佣金;2=固定比例
          commission: this.couponForm.commission, // 推广佣金
          commissionRate: this.couponForm.commissionRate, // 推广比例
        }
        couponForm.id = this.PrimaryKeyCouponId;
        couponForm.price = this.couponForm.price ? this.couponForm.price : 0; // 处理售价
        couponForm.useThreshold = this.couponForm.useThreshold ? this.couponForm.useThreshold : 0; // 处理使用门槛
        couponForm.receiveNumber = this.couponForm.receiveNumber ? this.couponForm.receiveNumber : 0; // 处理每人可领取
        addParams.ActivityCoupons = couponForm;
        getUpdateActivityCoupon(addParams).then((data) => {
          if (data.ResultCode == 1) {
            this.$swal({
              type: "success",
              text: "编辑优惠券 操作成功",
            });
            this.loadingBut = false;
            this.loadingButText = '确定';
            this.$emit("newAdd", 2);
          }
        });
      } else {
        // 新增优惠券入参
        let couponForm = JSON.parse(JSON.stringify(this.couponForm));
        let addParams = {
          activityId: this.addGoodsFormId, // 活动id
          brandTypeId: this.couponForm.brandTypeId, // 品类id
          brandId: this.couponForm.brandId, // 品牌id
          bbId: this.couponForm.bbId ? this.couponForm.bbId : this.dpid, // 店铺id
          number: this.couponForm.number, // 发放数量
          commissionMode: this.commissionMode == '1' ? '1' : '2', // 佣金类型1=固定佣金;2=固定比例
          commission: this.couponForm.commission, // 推广佣金
          commissionRate: this.couponForm.commissionRate, // 推广比例
          operatorId: localStorage.Id, // 操作人id
          // ActivityCoupons: couponForm
        }
        couponForm.price = this.couponForm.price ? this.couponForm.price : 0; // 处理售价
        couponForm.useThreshold = this.couponForm.useThreshold ? this.couponForm.useThreshold : 0; // 处理使用门槛
        couponForm.receiveNumber = this.couponForm.receiveNumber ? this.couponForm.receiveNumber : 0; // 处理每人可领取
        addParams.ActivityCoupons = couponForm;
        getInsertActivityCoupon(addParams).then((data) => {
          if (data.ResultCode == 1) {
            this.$swal({
              type: "success",
              text: "新增优惠券 操作成功",
            });
            this.loadingBut = false;
            this.loadingButText = '确定';
            this.$emit("newAdd", 2);
          }
        });
      }
      
    },

    // 添加延迟
    saveAddGoods_late(){
      this.loadingBut = true;
      this.loadingButText = '提交中...';
      setTimeout(() => {
        this.saveAddGoods();
        this.loadingBut = false;
        this.loadingButText = '确定';
      }, 0)
    },
    // 保存添加的活动商品
    saveAddGoods() {
      if (this.addShopType == 2 || this.addShopType == 3) {
        if (this.addGoodsForm.goodBrand == "") {
          this.$swal({
            type: "warning",
            text: "请选择商品品牌",
          });
          return false;
        }
      }
      if (this.addShopType == 1 || this.addShopType == 2 || this.addShopType == 3) {
        if (!this.addGoodsForm.goodModelCode) {
          this.$swal({
            type: "warning",
            text: "请输入商品编码",
          });
          return false;
        }
        if (!this.addGoodsForm.title) {
          this.$swal({
            type: "warning",
            text: "请输入商品名称",
          });
          return false;
        }
        if (!this.addGoodsForm.marketPrice) {
          this.$swal({
            type: "warning",
            text: "请输入市场价",
          });
          return false;
        }
        if (Number(this.addGoodsForm.marketPrice) < 0.01 || Number(this.addGoodsForm.marketPrice) > 99999999.99){
          this.$swal({
            type: "warning",
            text: "请输入正确的市场价,范围应在 ￥0.01～99999999.99,并且只能保留两位小数",
          });
          return false;
        }
        if (!this.goodsImgUrl) {
          this.$swal({
            type: "warning",
            text: "请上传商品图片",
          });
          return false;
        }

      }
      // if (!Number(this.addGoodsForm.commissionRate) && (this.addShopType == 2 || this.addShopType == 3)){
      //   this.$swal({
      //     type: "warning",
      //     text: "请输入佣金比例",
      //   });
      //   return false;
      // }
      
      // 判断 佣金比例 是否有回填数据
      // if(this.fill) {
      //   if ((Number(this.addGoodsForm.commissionRate) < this.fillData.commissionRate ||
      //     Number(this.addGoodsForm.commissionRate) > 100) && (this.addShopType == 2 || this.addShopType == 3)){
      //     this.$swal({
      //       text: `佣金比例需输入${this.fillData.commissionRate}%-100%之间的数字`,
      //       type: "warning",
      //     });
      //     return false;
      //   }
      // }
      if ((Number(this.addGoodsForm.commissionRate) < 0 || Number(this.addGoodsForm.commissionRate) > 30) &&
        (this.addShopType == 2 || this.addShopType == 3)){
        this.$swal({
          text: "佣金比例需输入0-30%之间的数字",
          type: "warning",
        });
        return false;
      }
      // 特价
      if (!this.addGoodsForm.promotionPrice && this.addShopType == 1) {
        this.$swal({
          type: "warning",
          text: "请输入促销价",
        });
        return false;
      }
      if (Number(this.addGoodsForm.promotionPrice) > Number(this.addGoodsForm.marketPrice) &&
        this.addShopType == 1){
        this.$swal({
          type: "warning",
          text: "促销价格不能超过市场价格",
        });
        return false;
      }
      if ((this.addGoodsForm.promotionPrice < 0.01 ||
        this.addGoodsForm.promotionPrice > 99999999.99) && this.addShopType == 1){
        this.$swal({
          type: "warning",
          text: "请输入正确的促销价,范围应在 ￥0.01～99999999.99,并且只能保留两位小数",
        });
        return false;
      }
      // 秒杀 & 团购
      if(this.addShopType == 2 || this.addShopType == 3) {
        if(this.addGoodsForm.unit == "") {
          this.$swal({
            type:"warning",
            text:"请选择单位"
          })
          return false;
        }
      }
      // 秒杀
      if(this.addShopType == 2) {
        if (!this.addGoodsForm.seckillModeId) {
          this.$swal({
            type: "warning",
            text: "请选择秒杀方式",
          });
          return false;
        }
        if (!this.addGoodsForm.seckillPrice) {
          this.$swal({
            type: "warning",
            text: "请输入秒杀价",
          });
          return false;
        }
        if (Number(this.addGoodsForm.seckillPrice) > Number(this.addGoodsForm.marketPrice)){
          this.$swal({
            type: "warning",
            text: "秒杀价格不能超过市场价格",
          });
          return false;
        }
        if (this.addGoodsForm.seckillPrice < 0 || this.addGoodsForm.seckillPrice > 99999999.99){
          this.$swal({
            type: "warning",
            text: "请输入正确的秒杀价,范围应在 ￥0～99999999.99,并且只能保留两位小数",
          });
          return false;
        }
        if ( !this.addGoodsForm.seckillDeposit && this.addGoodsForm.seckillModeId == 2){
          this.$swal({
            type: "warning",
            text: "请输入秒杀定金",
          });
          return false;
        }
        if (Number(this.addGoodsForm.seckillDeposit) > Number(this.addGoodsForm.seckillPrice)){
          this.$swal({
            type: "warning",
            text: "秒杀定金不能超过秒杀价",
          });
          return false;
        }
        if (this.addGoodsForm.seckillDeposit < 0 || this.addGoodsForm.seckillDeposit > 99999999.99){
          this.$swal({
            type: "warning",
            text: "请输入正确的秒杀定金,范围应在 ￥0～99999999.99,并且只能保留两位小数",
          });
          return false;
        }
        // 秒杀数量
        if (this.addGoodsForm.seckillStock == "") {
          this.$swal({
            type: "warning",
            text: "请输入秒杀数量",
          });
          return false;
        }
        if (this.addGoodsForm.seckillStock < 1 || this.addGoodsForm.seckillStock > 9999999){
          this.$swal({
            type: "warning",
            text: "请输入正确的秒杀数量,范围应在 1～99999999",
          });
          return false;
        }
        // 秒杀日期 & 秒杀时间
        if(this.addGoodsForm.spikeDate == '') {
          this.$swal({
            type: "warning",
            text: "请选择秒杀日期",
          });
          return false;
        }
        if(this.addGoodsForm.spikeTime == "") {
          this.$swal({
            type: "warning",
            text: "请选择秒杀时间",
          });
          return false;
        }
      }
      // 团购
      if(this.addShopType == 3) {
        if (!this.addGoodsForm.groupModeId) {
          this.$swal({
            type: "warning",
            text: "请选择拼团方式",
          });
          return false;
        }
        if (!this.addGoodsForm.groupPrice) {
          this.$swal({
            type: "warning",
            text: "请输入团购价",
          });
          return false;
        }
        if (Number(this.addGoodsForm.groupPrice) > Number(this.addGoodsForm.marketPrice)) {
          this.$swal({
            type: "warning",
            text: "团购价格不能超过市场价格",
          });
          return false;
        }
        if (this.addGoodsForm.groupPrice < 0 || this.addGoodsForm.groupPrice > 99999999.99) {
          this.$swal({
            type: "warning",
            text: "请输入正确的团购价,范围应在 ￥0～99999999.99,并且只能保留两位小数",
          });
          return false;
        }
        if (!this.addGoodsForm.groupDeposit && this.addGoodsForm.groupModeId == 2){
          this.$swal({
            type: "warning",
            text: "请输入团购定金",
          });
          return false;
        }
        if (Number(this.addGoodsForm.groupDeposit) > Number(this.addGoodsForm.groupPrice) && this.addGoodsForm.groupModeId == 2){
          this.$swal({
            type: "warning",
            text: "团购定金不能超过团购价",
          });
          return false;
        }
        if ( (this.addGoodsForm.groupDeposit < 0 || this.addGoodsForm.groupDeposit > 99999999.99)&&this.addGoodsForm.groupModeId == 2){
          this.$swal({
            type: "warning",
            text: "请输入正确的团购定金,范围应在 ￥0～99999999.99,并且只能保留两位小数",
          });
          return false;
        }
        if (!this.addGoodsForm.groupNumber) {
          this.$swal({
            type: "warning",
            text: "请输入成团人数",
          });
          return false;
        }
        if (this.addGoodsForm.groupNumber < 2 || this.addGoodsForm.groupNumber > 9999999){
          this.$swal({
            type: "warning",
            text: "请输入正确的成团人数,范围应在 2～99999999",
          });
          return false;
        }
      }
      // 签到礼
      // if (!this.addGoodsForm.tzrPrice && this.addShopType == 5) {
      //   this.$swal({
      //     type: "warning",
      //     text: "请输入甄惠装价",
      //   });
      //   return false;
      // }
      // if ((this.addGoodsForm.tzrPrice < 0 ||
      //   this.addGoodsForm.tzrPrice > 99999999.99) && this.addShopType == 5){
      //   this.$swal({
      //     type: "warning",
      //     text: "请输入正确的甄惠装价,范围应在 ￥0～99999999.99,并且只能保留两位小数",
      //   });
      //   return false;
      // }
      // 预约签到礼 & 到店打卡礼 & 连单礼
      if(this.addShopType == 5 || this.addShopType == 6 || this.addShopType == 7) {
        if (!this.addGoodsForm.stock) {
          this.$swal({
            type: "warning",
            text: "请输入礼品数量",
          });
          return false;
        }
        if (this.addGoodsForm.stock < 1 || this.addGoodsForm.stock > 9999999){
          this.$swal({
            type: "warning",
            text: "请输入正确的礼品数量,范围应在 1～99999999",
          });
          return false;
        }
        // 预约签到礼
        if (this.addShopType == 5) {
          if (!this.addGoodsForm.writeOffDate) {
            this.$swal({
              type: "warning",
              text: "请选择核销开始日期",
            });
            return false;
          }
          if (!this.addGoodsForm.writeOffEndDate) {
            this.$swal({
              type: "warning",
              text: "请选择核销结束日期",
            });
            return false;
          }
          if (Date.parse(this.addGoodsForm.writeOffDate)>Date.parse(this.addGoodsForm.writeOffEndDate)) {
            this.$swal({
              type: "warning",
              text: "核销结束时间不能早于开始时间",
            });
            return false;
          }
          // if (!this.addGoodsForm.writeOffBeginTime) {
          //   this.$swal({
          //     type: "warning",
          //     text: "请选择起始时间",
          //   });
          //   return false;
          // }
          // if (!this.addGoodsForm.writeOffEndTime) {
          //   this.$swal({
          //     type: "warning",
          //     text: "请选择结束时间",
          //   });
          //   return false;
          // }
        }
        if(this.journalArr.length == 0){
          this.$swal({
            type:'warning',
            text: '请至少增加一项礼品',
          })
          return false;
        }
        // 连单礼
        if(this.addShopType == 7) {
          if (!this.liandanshul) {
            this.$swal({
              type: "warning",
              text: "请输入连单数量",
            });
            return false;
          }
          if (!this.meidanjine) {
            this.$swal({
              type: "warning",
              text: "请输入每单金额",
            });
            return false;
          }
        }
      }
      // 商品简介 & 活动说明
      if (this.addShopType == 1 || this.addShopType == 2 || this.addShopType == 3) {
        if(!this.addGoodsForm.productProfile){
          this.$swal({
            type: "warning",
            text: "请输入商品简介",
          });
          return false;
        }
        if(!this.addGoodsForm.activityDesc){
          this.$swal({
            type: "warning",
            text: "请输入活动说明",
          });
          return false;
        }
      }
      // 公共入参
      let addGoodsForm = JSON.parse(JSON.stringify(this.addGoodsForm));
      let addParams = {
        userId: localStorage.Id, // 用户id
        activityId: this.addGoodsFormId,
        id: this.addGoodsForm.goodsId, // 对应列表中的goodsid
        goodsBrandTypeId: this.addGoodsForm.goodsBrandTypeId, // 品类id
        brandId: this.addGoodsForm.brandId, // 品牌id
        // bbId: this.addGoodsForm.bbId ? this.addGoodsForm.bbId : localStorage.BbId, // 品牌商id
        bbId: this.couponForm.bbId?this.couponForm.bbId:this.dpid, // 店铺
        goodModelCode: this.addGoodsForm.goodModelCode, // 商品编码
        title: this.addGoodsForm.title, // 标题
        marketPrice: this.addGoodsForm.marketPrice, // 市场价
        tzrPrice: this.addGoodsForm.tzrPrice // 甄惠装价
      }
      var headers = {
          headers: {
            "Content-Type": "application/json;"
          }
        }
      // 新增特价
      if(this.addShopType == 1) {
        addParams.SpecialOfferGoodsInsertParamter = addGoodsForm;
        addParams.SpecialOfferGoodsInsertParamter.activityId = this.addGoodsFormId;
        addParams.SpecialOfferGoodsInsertParamter.id = this.newSoid; // 对应列表id
        getEditSpecialOfferGoods(addParams).then((data) => {
          if (data.ResultCode == 1) {
            this.$swal({
              type: "success",
              text: "操作成功",
            });
            this.$emit("newAdd", 2);
          }
        });
      };
      // 新增秒杀
      if(this.addShopType == 2) {
        addParams.SeckillGoodsParameter = addGoodsForm;
        addParams.SeckillGoodsParameter.activityId = this.addGoodsFormId;
        addParams.SeckillGoodsParameter.id = this.newSoid; // 对应列表id
        // 判断如果选择0元秒杀 秒杀定金设置为 0 否则就是它本身
        addParams.SeckillGoodsParameter.seckillModeId == 1 ? addParams.SeckillGoodsParameter.seckillDeposit = 0 : addParams.SeckillGoodsParameter.seckillDeposit;
        getEditSeckillGoods(addParams,headers).then((data) => {
          if (data.ResultCode == 1) {
            this.$swal({
              type: "success",
              text: "操作成功",
            });
            this.$emit("newAdd", 2);
          }
        });
      };
      // 新增团购
      if(this.addShopType == 3) {
        addParams.GroupBuyGoods = addGoodsForm;
        addParams.GroupBuyGoods.activityId = this.addGoodsFormId;
        addParams.GroupBuyGoods.id = this.newSoid; // 对应列表id
        // 判断如果选择0元拼团 团购定金:设置为 0 否则就是它本身
        addParams.GroupBuyGoods.groupModeId == 1 ? addParams.GroupBuyGoods.groupDeposit = 0 : addParams.GroupBuyGoods.groupDeposit;
        getEditGroupBuyGoods(addParams,headers).then((data) => {
          if (data.ResultCode == 1) {
            this.$swal({
              type: "success",
              text: "操作成功",
            });
            this.$emit("newAdd", 2);
          }
        });
      };
      // 新增预约签到礼
      if(this.addShopType == 5) {
        addParams.ReservationGoods = addGoodsForm;
        addParams.ReservationGoods.activityId = this.addGoodsFormId;
        addParams.ReservationGoods.id = this.newSoid; // 对应列表id
        addParams.ReservationGoods.coverImg = this.journalArr.map(item => {
          return {
            name: item.name,
            imgUrl: item.imgUrl.replace(localStorage.BaseOssUrl, '')
          }
        }); // 礼品集合
        getEditReservationGoods(addParams,headers).then((data) => {
          if (data.ResultCode == 1) {
            this.$swal({
              type: "success",
              text: "操作成功",
            });
            this.$emit("newAdd", 2);
          }
        });
      };
      // 新增、编辑 - 到店打卡礼
      if(this.addShopType == 6) {
        let addParams = {
          id: this.addGoodsForm.bbId?this.newSoid:0, // 对应列表id
          activityId: this.addGoodsFormId,
          number: this.addGoodsForm.stock,
          desc: this.dddklGzsm, // 规则说明
          imgUrls: this.journalArr.map(item => {
            return {
              name: item.name,
              imgUrl: item.imgUrl.replace(localStorage.BaseOssUrl, '')
            }
          }), // 礼品集合
          bbIds: this.alreadyChoose, // 打卡店铺集合[ 店铺id ]
        }
        postAddeditToStore(addParams).then(data => {
          if (data.resultCode == 1) {
            this.$swal({
              type: "success",
              text: "操作成功",
            });
            this.$emit("newAdd", 2);
          }
        });
      };
      // 新增、编辑 - 连单礼
      if(this.addShopType == 7) {
        let addParams = {
          id: this.addGoodsForm.bbId?this.newSoid:0, // 礼品id、新增时传0
          activityId: this.addGoodsFormId, // 活动id
          number: this.addGoodsForm.stock, // 礼品数量
          continuityOrderNumber: this.liandanshul, // 连单数量
          orderPrice: this.meidanjine, // 每单金额（单位：元）
          desc: this.ldlGzsm, // 规则说明
          imgUrls: this.journalArr.map(item => {
            return {
              name: item.name,
              imgUrl: item.imgUrl.replace(localStorage.BaseOssUrl, '')
            }
          }), // 礼品集合
        }
        postAddeditContinuityOrder(addParams).then(data => {
          if (data.resultCode == 1) {
            this.$swal({
              type: "success",
              text: "操作成功",
            });
            this.$emit("newAdd", 2);
          }
        });
      };
    },
    // 新增特价商品
    showTwoStep() {
      this.addActiveTitle = "特价商品";
      this.showStep = false;
      this.addActive = 1;
    },
    
    // 增加礼品项
    addJournal() {
      if(this.anwser == ''){
        this.$swal({
          type:'warning',
          text: '请输入礼品名称',
        })
        return false;
      }
      if(this.detailImgUrlarr == ''){
        this.$swal({
          type:'warning',
          text: '请上传礼品图片',
        })
        return false;
      }
      this.journalArr.push({name: this.anwser, imgUrl: this.detailImgUrlarr})
      this.anwser = ''; // 清空礼品名称
      this.detailImgUrlarr = ''; // 清空礼品图片
    },
    // 刪除礼品项
    shanchu(index) {
      this.journalArr.splice(index, 1);
    },
    // 店铺列表
    dianpuList() {
      let params = {
        activityId: this.addGoodsFormId, // 活动id
        giftId: this.newSoid?this.newSoid:0, // 礼品id
      };
      getToStoreGiftBusiness(params).then(res => {
        let data = res.resultObj;
        this.TData = data || [];
      })
    },
    // 获取店铺名称
    getdianpuname(id){
      let the = this.TData.find(item => item.id===id)
      if (the){
        return the.name
      }
      return ''
    },
    // 选择店铺
    handleXzdp() {
      this.dialogVisible = true;
      this.alreadyChooseTemp = JSON.parse(JSON.stringify(this.alreadyChoose))
    },
    // 选中店铺
    checkImg(val, index) {
      let i = this.alreadyChooseTemp.indexOf(val.id)
      if (i>-1){
        this.alreadyChooseTemp.splice(i, 1)
      }else{
        this.alreadyChooseTemp.push(val.id)
      }
    },
    // 取消选中
    canCheck(item, index) {
      this.alreadyChooseTemp.splice(this.alreadyChooseTemp.indexOf(item.id), 1)
    },
    // 查询
    getSortList() {
      this.tempkey = this.searchKey;
    },
    // 确认-已选择店铺
    confirmSetRole() {
      this.$swal({
          text: "设置成功",
          type: "success"
        });
      this.dialogVisible = false;
      this.alreadyChoose = this.alreadyChooseTemp
    },

    // 特价商品详情-列表
    cooperationList(tid,bid){
      let addParams = {
        activityId: this.addGoodsFormId, // 活动ID
        shopId: tid, // 店铺ID
        goodsName: this.EnterpriseName, // 商品名称 模糊匹配
        pageIndex: this.pageIndexFive,
        pageSize: 10,
      };
      specialpriceGetgoods(addParams).then(data => {
        if (data) {
          console.log(data,'特价商品详情-列表')
          if (data.resultCode == 1) {
            this.brandList = data.resultObj.list;
            this.totalRowsCountFive = data.resultObj.totalcount;
          } else {
            this.brandList = [];
            this.totalRowsCountFive = 0;
          }
        }
      })
    },
    // 分页
    handleTabFive(val) {
      this.pageIndexFive = val;
      this.cooperationList(this.dpid,this.bid)
    },
    //查询
    onSubmit() {
      this.cooperationList(this.dpid,this.bid)
      this.pageIndex = 1;
      // this.getInit();
    },
    // 特价商品详情-复选框
    handleSelectionChange(val) {
      console.log(val,'12312321')
      this.groupWorkArr = [];
      val.forEach(element => {
        this.groupWorkArr.push(element.goodsid);
      });
    },
    // 特价商品-保存
    addTjsp(){
      if(this.groupWorkArr.length>0){
        let addParams = {
          activityId: this.addGoodsFormId,
          shopId: this.dpid,
          goodsIds: this.groupWorkArr.join(','),
          operatorId: localStorage.Id, // 操作人id
        };
        specialpriceSavegoods(addParams).then(data => {
          if (data) {
            if (data.resultCode == 1) {
              this.$swal({
                type: "success",
                text: "添加成功！",
              });
              // this.cooperationList(this.dpid,this.bid)
              this.$emit("newAdd", 2);
            }
          }
        })
      } else {
        this.$swal({
          type: "warning",
          text: "请先勾选列表",
        });
      }
    },
    // 树列
    brandTypeTree(){
      this.dpid==null?0:this.dpid
      let obj = {
        activityId: this.addGoodsFormId, // 活动ID，默认0（注：activityId和maId必须传一个）
        maId: this.lmid?this.lmid:0, // 联盟ID，默认0（注：activityId和maId必须传一个，传联盟ID则查联盟下的所有店铺）
        statusId: 1, // 状态 1=开启，2=关闭、3=过期（注：默认1，传0查全部状态)
        shopId: this.dpid?this.dpid:0, // 店铺ID
      };
      getactivityshop(obj).then(data => {
        if (data) {
          console.log(data,'我的联盟tab获取合作品类树')
          if (data.resultCode == 1) {
            this.oneData = data.resultObj;
            this.defaultCheckedKeys.push(data.resultObj[0].id);
            this.dpid = data.resultObj[0].id;
            this.bid = [];
            this.cooperationList(data.resultObj[0].id);
          }
        }
      })
    },
    // 选择品类树列表
    handleNodeClick(data) {
      this.dpid = data.id;
      console.log(data,'12321321')
      // this.EnterpriseName = '';     //清空搜索框
      this.cooperationList(this.dpid);
    },
    // 店铺
    handleDp(val){
      this.getBrandByCityId();
    },
    // 商品品牌
    handleSppp(val) {
      this.addGoodsForm.goodsBrandTypeId = val[0];
      this.addGoodsForm.brandId = val[1];
    },
    //获取 查询品牌商代理的品类品牌列表
    getBrandByCityId() {
      var obj = {
        bbId: this.couponForm.bbId?this.couponForm.bbId:this.dpid, // 店铺id
      };
      getMerchantGoodsBrandTypeList(obj).then(data => {
        if(data.ResultCode == 1){
          let that = this;
          let brandList = [];
          data.ResultObj.map(item => {
            let brandData = {value:item.Id,label:item.Name,children:[]}
            brandList.push(brandData)
            if(item.BaseDataList != null) {
              item.BaseDataList.map(brandBusiness => {
                brandData.children.push({value:brandBusiness.Id, label:brandBusiness.Name})
              })
            }
          });
          that.optionExhibitions = brandList
        }else if(data.ResultCode in {0:0,2:2}){
          this.$swal({
            type:'error',
            text: data.ResultMsg,
          })
        }
      });
    },
  },
}
</script>
<style scoped>
/* 多图 */
.upPictures {
  width: 88%;
  /* float: left; */
}
.multigraph {
  width: 80px;
  height: 80px;
  position: relative;
  float:left;
  margin-right:10px;
}
.upBtn {
  width: 80px;
  height: 80px;
  line-height: 80px;
  border: 1px solid #DCDFE6;
  font-size: 26px;
  color: #999;
}
.spPicWenan {
  color: #999;
  line-height: 10px;
}
/* 穿梭框 */
.shuttle {
  border: 1px solid #eee;
}
.TLeft {
  width: 49%;
  float: left;
  height: 220px;
  overflow-y: auto;
  flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  justify-content: space-between;
  padding-left: 40px;
  box-sizing: border-box;
}
.TLeft p {
  width: 80%;
  /* margin-left: 20px; */
  color: #000;
  font-size: 12px;
}
/* 选择框 */
.TLeft .left_img {
  width: 16px;
  height: 16px;
  z-index: 999;
  margin-bottom: 6px;
  cursor: pointer;
}
.border_r {
  border-left: 1px solid #eee;
  height: 220px;
  overflow-y: auto;
  padding-left: 20px;
  padding-bottom: 20px;
}
.TRight {
  position: relative;
  /* width: 60%; */
  height: 50px;
  display: inline-block;
}
.TRight p {
  background: #f2f2f2;
  text-align: center;
  margin-top: 18px;
  margin-left: 13px;
  padding: 5px 15px;
}
.TRight img {
  position: absolute;
  top: 12px;
  right: -5px;
  cursor: pointer;
}
/* 店铺列表 */
.shut p {
  border-right: 1px solid #eee;
  height: 50px;
  background: #bbb;
  line-height: 50px;
  padding-left: 20px;
  font-size: 12px;
  color: #000;
  opacity: 0.49;
  margin: 15px 0 0 0;
}
/* 礼品名称 & 礼品图片 */
.dottedLine {
  margin-top: 5px;
}
.primarybtn {
  width: 10%;
  position: absolute;
  right: 20px;
}
/* 打卡店铺 */
.dakadianpu {
  width: 150px;
  height: 260px;
  border: 1px solid #eee;
  overflow: scroll;
  line-height: 18px;
  padding: 0 10px;
}
/* 特价商品 */
.displayFlex{
  display: flex;
  justify-content: flex-start;
}
.card1{
  width: 30%;
  overflow-y: auto;
}
.card2{
  width: 70%;
  overflow-y: auto;
  position: relative;
}
</style>


// WEBPACK FOOTER //
// addActiviteForm.vue?7734ec11